













































import Vue from 'vue'
import { mapGetters } from 'vuex'
import models from '@/mixins/models-mixin'
import persons from '@/mixins/persons-mixin'
import Person from '@/types/Person.interface'
import Address from '@/types/Address.interface'
export default Vue.extend({
    mixins: [models, persons],
    data: () => ({
        cell: 'text-truncate',
        column: 'col-sm-4 px-1 py-0 line'
    }),
    computed: {
        ...mapGetters([
            'appDrawerIsMin',
            'personCreateInputs',
            'searchBarList',
            'searchBarListVisible',
            'searchBarText',
            'tenant'
        ]),
        drawerWidth(): number {
            return this.appDrawerIsMin && this.$vuetify.breakpoint.mdAndUp ? 65 : 190
        },
        nameIsOptional() {
            const optional =
                this.tenant.data_provider !== 'QBO' &&
                this.tenant.data_provider !== 'XERO'
            return optional
        },
        //  The v-model that tracks the selected list index
        searchBarIndex: {
            get(): number {
                return this.$store.getters.searchBarIndex
            },
            set(value: number): void {
                this.$store.commit('searchBarIndexSet', value)
            }
        },
        style(): object {
            return {
                position: 'absolute',
                left: '0px',
                right: '0px',
                top: '50px',
                width: `calc(100vw - ${this.drawerWidth}px)`,
                'z-index': 7,
                overflow: 'hidden',
                'overflow-y': 'scroll',
                'max-height': '80vh',
                'border-right': `1px solid ${this.$colors.grey.darken1}`,
                'border-left': `1px solid ${this.$colors.grey.darken1}`,
                'border-bottom': `2px solid ${this.$colors.grey.darken1}`,
                'border-radius': '0 0 5px 5px'
            }
        }
    },
    methods: {
        addr(address: Address): string {
            //  Convert this address to just a string representation
            const str = this.$options.filters.addressString(address)

            //  Highlight the address in our search bar text
            const highlight = this.$options.filters.highlight(str, this.searchBarText)

            //  Return the highlighted vresion of the text
            return highlight
        },
        backgroundColor(index: number): string {
            //  Determine if the list item is selected
            const isSelected = this.searchBarIndex === index

            //  If the item is selected return light purple
            if (isSelected) return this.$colors.mdLightPurple50

            //  Else, return very light grey
            return this.$colors.grey.lighten6
        },
        name(person: Person): string {
            //  Grab the name from our person
            const name = this.$options.filters.personFullNameOrEmail(person)

            //  Highlight the name in our search bar text
            const highlight = this.$options.filters.highlight(name, this.searchBarText)

            //  Return the highlighted version of the text
            return highlight
        },
        email(person: Person): string {
            //  Grab the email from the person
            const email = window.getProps(person, ['email_default', 'address'])

            //  Highlight the email in our search bar text
            const highlight = this.$options.filters.highlight(email, this.searchBarText)

            //  Return the highlighted version of the text
            return highlight
        },
        phone(person: Person): string {
            //  Grab the msisdn from this person
            const msisdn = window.getProps(person, ['phone_default', 'msisdn'])

            //  Make our phone all pretty
            const phone = this.$options.filters.phone(msisdn)

            //  Add a highlight to this phone number in our search bar text
            const highlight = this.$options.filters.highlight(phone, this.searchBarText)

            //  Return the highlighted version of the text
            return highlight
        },
        //  Navigates to the person
        onPersonSelectedHandler(person: Person): void {
            //  If the person does NOT exist, do nothing
            if (!person) return

            //  Else, emit goToPerson
            this.$emit('goToPerson', person)
        },
        //  Pops a new contact dialog
        popNewContact(model: Person): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'New Contact',
                icon: 'mdi-account',
                color: 'primary',
                closeable: true,
                component: 'new-contact-selector',
                props: {
                    model: model,
                    withImport: true
                },
                callback: (person: Person): void => {
                    //  Close the app dialog
                    this.$store.dispatch('dialogClose', 'APP')

                    //  Navigate to the person's messages
                    this.$router.push(`/inbox?channel=${person.primary_channel_id}`)
                }
            })
        },
        searchDeep(): void {
            this.$emit('searchDeep')
        }
    },
    watch: {
        searchBarList(): void {
            //  Reset the selected index when the search list changes
            this.searchBarIndex = -1
        }
    }
})
